export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fc7cb0f1cd34300eaa89e71c1678199b8d17e0fbf&name=fetchTypeahead!'